import React from "react";

export default function NiveauInstantieIcon(color) {
return(
<svg version="1.1" id="Laag_4" width="65px" height="65px" viewBox="5 5 65 65">
<g>
	<g>
		<path fill={color} d="M43.324,55.928V29.813H26.977v26.115h-5.573v1l37.661-0.002v-1L43.324,55.928z M36.735,55.928h-3.168
			v-4.439h3.168V55.928z M42.324,55.928h-4.589v-5.439h-5.168v5.439l-4.59,0.001V30.813h14.347V55.928z M39.806,45.001h-1v3.429h1
			V45.001z M35.651,33.182h-1v3.429h1V33.182z M39.806,33.182h-1v3.429h1V33.182z M39.806,39.091h-1v3.429h1V39.091z M35.651,45.001
			h-1v3.429h1V45.001z M31.497,39.091h-1v3.429h1V39.091z M31.497,33.182h-1v3.429h1V33.182z M31.497,45.001h-1v3.429h1V45.001z
			M35.651,39.091h-1v3.429h1V39.091z"/>
	</g>
</g>
<g>
	<polygon fill={color} points="54.672,56.429 53.672,56.429 53.672,36.813 43.324,36.813 43.324,56.429 42.324,56.429
		42.324,35.813 54.672,35.813 	"/>
</g>
<g>
	<g>
		<g>
			<rect x="45.844" y="39.091" fill={color} width="1" height="3.429"/>
		</g>
		<g>
			<rect x="49.998" y="39.091" fill={color} width="1" height="3.429"/>
		</g>
	</g>
	<g>
		<g>
			<rect x="45.844" y="45.001" fill={color} width="1" height="3.429"/>
		</g>
		<g>
			<rect x="49.998" y="45.001" fill={color} width="1" height="3.429"/>
		</g>
	</g>
</g>
<g>
	<polygon fill={color} points="50.559,56.284 49.559,56.284 49.559,52.488 47.391,52.488 47.391,56.284 46.391,56.284
		46.391,51.488 50.559,51.488 	"/>
</g>
</svg>
);
}